module.exports = __webpack_public_path__ + "img/6.103c5f65.jpg";